module.exports = __webpack_public_path__ + "static/media/shopping-bag-dark.fa5954d5.svg";